function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as t } from "./index.es33.js";
import { memo as y } from "react";
import { clsx as m } from "./index.es105.js";
import { Typography as x } from "./index.es35.js";
import "./index.es36.js";
import r from "./index.es684.js";
var N = /*#__PURE__*/y(function (_ref) {
  var s = _ref.children,
    e = _ref.isToday,
    p = _ref.isDisabled,
    n = _ref.isHighlighted,
    o = _ref.isStartSelected,
    a = _ref.isEndSelected,
    d = _ref.onClick,
    i = _ref.onMouseEnter,
    l = _ref.onMouseLeave,
    c = _ref.onFocus;
  return t.jsx("button", {
    type: "button",
    onMouseEnter: i,
    onMouseLeave: l,
    onClick: d,
    onFocus: c,
    disabled: p,
    className: r.container,
    children: t.jsx("div", {
      className: m(r.wrapper, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, r.startSelected, o), r.endSelected, a), r.endAndStartSelected, o && a), r.highlightedWrapper, n)),
      children: t.jsx(x.Body2, {
        as: "div",
        className: m(r.inner, r.calendarDayItem, _defineProperty(_defineProperty({}, r.today, e), r.notToday, !e)),
        children: s
      })
    })
  });
});
export { N as Day };